import CICESE from '../../../assets/images/sponsors/logo_cicese.png';

export const Sponsors = () => {
  return (
    <>
      <section className="snn-page-section snn-topics">
        <h2 className="snn-title">Instituciones participantes</h2>
        <div className="snn-topic-section snn-sponsors-section">
          <div>
            <img src={CICESE} alt="cic logo" />
          </div>
        </div>
      </section>
    </>
  );
};
